export const IS_CREATE_SUB_SUB_CATEGORY = "IS_CREATE_SUB_SUB_CATEGORY";
export const IS_UPDATE_SUB_SUB_CATEGORY = "IS_UPDATE_SUB_SUB_CATEGORY";
export const SUB_SUB_CATEGORY_LIST = "SUB_SUB_CATEGORY_LIST";
export const SUB_SUB_CATEGORY_LIST_META = "SUB_SUB_CATEGORY_LIST_META";
export const IS_SUB_SUB_CATEGORY_LIST_LOADING = "IS_SUB_SUB_CATEGORY_LIST_LOADING";
export const IS_SUB_SUB_CATEGORY_STATUS_UPDATING = "IS_SUB_SUB_CATEGORY_STATUS_UPDATING";
export const AFTER_CREATED = "AFTER_CREATED";
export const AFTER_UPDATED = "AFTER_UPDATED";
export const AFTER_DELETED = "AFTER_DELETED";
